import { render, staticRenderFns } from "./newRequestForm.vue?vue&type=template&id=5bbbc61d&scoped=true&"
import script from "./newRequestForm.vue?vue&type=script&lang=js&"
export * from "./newRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./newRequestForm.vue?vue&type=style&index=0&id=5bbbc61d&prod&lang=css&"
import style1 from "./newRequestForm.vue?vue&type=style&index=1&id=5bbbc61d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbbc61d",
  null
  
)

export default component.exports